module.exports = __webpack_public_path__ + "img/cp1-4.6139a4aa.jpg";